// @flow
import Resource from 'speed-js-core/src/api/Resource';

export default class ServiceAccessResource extends Resource {
    basePath: string = 'services/access/';

    objectPath: string = 'services/access/{ident}/';
}
